import React, { useState } from 'react';
import AdminCreate from "./components/adminCreate";
import AdminEdit from "./components/adminEdit";
import AdminList from "./components/adminList";
import AdminDelete from "./components/adminDelete";
import { Button, Container, Row, Col } from "react-bootstrap";
import { Navigate, useNavigate } from 'react-router-dom';

export default function Admin({ loginInfo, setLoginInfo }) {
    const navigate = useNavigate();
    const [selectedButton, setSelectedButton] = useState(null);
    // Renders the appropriate component based on selected button
    const conditionalRender = () => {
        if (!loginInfo.loggedIn) {
            return <Navigate to="/app/admin-login" replace />;
        }
        switch (selectedButton) {
            case "create":
                return <AdminCreate />;
            case "edit":
                return <AdminEdit />;
            case "list":
                return <AdminList />;
            case "delete":
                return <AdminDelete />;
            default:
                return <div>Select an option</div>;
        }
    };

    return (
        <div className='admin-container'>
            <h1 className='admin-title'>Early Bird Management</h1>
            <Button
                onClick={() => navigate("/app/moderation-view")}
            >
                Moderation
            </Button>
            <Row className='admin-row'>
                <Col xs={2} md={2} lg={2} className='button-list'>
                    <Row>
                        <Button
                            onClick={() => setSelectedButton("create")}
                            className={`mb-2 ${selectedButton == "create" ? 'selected' : ''}`}
                            variant='primary'>
                            Create
                        </Button>
                    </Row>
                    <Row>
                        <Button
                            onClick={() => setSelectedButton("edit")}
                            className={`mb-2 ${selectedButton == "edit" ? 'selected' : ''}`}
                            variant='primary'>
                            Edit
                        </Button>
                    </Row>
                    <Row>
                        <Button
                            onClick={() => setSelectedButton("list")}
                            className={`mb-2 ${selectedButton == "list" ? 'selected' : ''}`}
                            variant='primary'>
                            List
                        </Button>
                    </Row>
                    <Row>
                        <Button
                            onClick={() => setSelectedButton("delete")}
                            className={`mb-2 ${selectedButton == "delete" ? 'selected' : ''}`}
                            variant='primary'>
                            Delete
                        </Button>
                    </Row>
                </Col>
                <Col xs={10} md={9} className='admin-content'>
                    {conditionalRender()}
                </Col>
            </Row>
        </div>
    );
}